import Response from "../../Data/Domain/Response";
import ownerData from "../Domain/DashboardOnwer";
import {getDashboardOwnerData} from "./DashboardOwner.service";

export async function getOwnerDataRepository(id, project_id) {
  const data = await getDashboardOwnerData(id, project_id);
  return new Response(data, ownerData).getSingle();
}
